@if (data$ | async; as data) {
  <app-warehouse-localization-details-form
    [data]="data"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
